// import qs from 'qs';
import axios from 'axios';
import config from '../common/config';

// Device fingerprinting helper
function collectDeviceInfo() {
  const deviceInfo = {};
  
  try {
    // Screen information (stable hardware characteristic)
    if (screen) {
      deviceInfo.screen_info = `${screen.width}x${screen.height}x${screen.colorDepth}`;
    }
    
    // Timezone (can help identify user, changes with travel but useful)
    deviceInfo.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    // Language preferences (stable user characteristic)
    deviceInfo.languages = navigator.languages ? navigator.languages.join(',') : navigator.language;
    
    // Platform information (stable)
    deviceInfo.platform = navigator.platform;
    
    // Hardware concurrency (CPU cores - stable)
    if (navigator.hardwareConcurrency) {
      deviceInfo.cpu_cores = navigator.hardwareConcurrency;
    }
    
    // Memory information (if available - stable)
    if (navigator.deviceMemory) {
      deviceInfo.device_memory = navigator.deviceMemory;
    }
    
    // Touch support (stable device characteristic)
    deviceInfo.touch_support = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
  } catch (error) {
    console.warn('Error collecting device info:', error);
  }
  
  return deviceInfo;
}

export default {
  authenticate(email, password=null, userToken=null, provider=null) {
    const formData = new FormData();
    // Send lowercase for server-side comparison
    formData.append('email', email.toLowerCase());
    formData.append('password', password);
    if( provider=="google")
      formData.append('googleIdToken', userToken);
    else if ( provider=="face-book")
      formData.append('facebookAccessToken', userToken);

    // Add device fingerprinting information
    const deviceInfo = collectDeviceInfo();
    if (deviceInfo.screen_info) {
      formData.append('screen_info', deviceInfo.screen_info);
    }
    if (deviceInfo.timezone) {
      formData.append('timezone', deviceInfo.timezone);
    }
    if (deviceInfo.languages) {
      formData.append('languages', deviceInfo.languages);
    }

    const referrerId = sessionStorage.getItem('affiliate_referrer_id');
    if (referrerId) formData.append('referrer_id', referrerId);

    return axios.post(`${config.config.ROOT_URL}/app_login`,formData);
  },

  registerNewUser(email, password, userName) {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('userName', userName);

    // Add device fingerprinting information for registration too
    const deviceInfo = collectDeviceInfo();
    if (deviceInfo.screen_info) {
      formData.append('screen_info', deviceInfo.screen_info);
    }
    if (deviceInfo.timezone) {
      formData.append('timezone', deviceInfo.timezone);
    }
    if (deviceInfo.languages) {
      formData.append('languages', deviceInfo.languages);
    }

    const referrerId = sessionStorage.getItem('affiliate_referrer_id');
    if (referrerId) formData.append('referrer_id', referrerId);

    return axios.post(`${config.config.ROOT_URL}/register_new_user_api`,formData);
  },

  requestPasswordReset(email, baseUrl) {
    const formData = new FormData();
    // Send lowercase for server-side comparison
    formData.append('email', email.toLowerCase());
    if (baseUrl) {
      formData.append('base_url', baseUrl);
    }
    return axios.post(`${config.config.ROOT_URL}/request_password_reset`, formData);
  },

  resetPassword(token, newPassword) {
    const formData = new FormData();
    formData.append('token', token);
    formData.append('newPassword', newPassword);
    return axios.post(`${config.config.ROOT_URL}/reset_password`, formData);
  },

  checkEmailExists(email) {
    const formData = new FormData();
    formData.append('email', email.toLowerCase());
    return axios.post(`${config.config.ROOT_URL}/check_user_auth_methods`, formData);
  },

  // Promote current logged-in user to ride manager
  makeRideManager(apptoken, currency) {
    return axios.post(
      `${config.config.ROOT_URL}/make_user_ride_manager`,
      { currency },
      {
        headers: {
          Authorization: `Bearer ${apptoken}`,
        },
      }
    );
  }
};
